import { ContractReviewApplyItem } from '../../../models/Entities/Contracts/ContractReview';
import { ContractReviewState, ContractReviewUnloadState } from '../../states/ContractReview.States';
import * as actions from '../../actions/ContractReview.Actions';

/**
 * Aplicación: guarda el resultado y lo vuelca en cada hallazgo procesado (`applyStatus`, `applyMessage`,
 * `currentValues`, `createdEntityId`), el estado de la revisión y, en `NewAddendum`, la adenda creada (D-7).
 */
export default function ContractReviewApplyReducer(state: ContractReviewState | undefined, action: any): ContractReviewState {
  const current = state ?? ContractReviewUnloadState;
  switch (action.type) {
    case actions.CONTRACT_REVIEW_APPLY_REQUEST:
      return { ...current, isApplying: true, applyResult: undefined, applyError: undefined };
    case actions.CONTRACT_REVIEW_APPLY_SUCCESS: {
      const result = action.result;
      const review = current.byId[action.reviewId];
      if (!result || !review) return { ...current, isApplying: false, applyResult: result };

      const items = new Map<number, ContractReviewApplyItem>(result.results.map((r: ContractReviewApplyItem) => [r.findingId, r]));
      const findings = review.findings?.map(f => {
        const item = items.get(f.id);
        return item
          ? {
              ...f,
              applyStatus: item.applyStatus,
              applyMessage: item.message ?? null,
              currentValues: item.currentValues ?? null,
              createdEntityId: item.createdEntityId ?? null
            }
          : f;
      });

      return {
        ...current,
        isApplying: false,
        applyResult: result,
        byId: {
          ...current.byId,
          [action.reviewId]: {
            ...review,
            status: result.status ?? review.status,
            createdAddendumId: result.createdAddendumId ?? review.createdAddendumId,
            findings
          }
        }
      };
    }
    case actions.CONTRACT_REVIEW_APPLY_FAILURE:
      return { ...current, isApplying: false, applyError: action.error };
    case actions.CONTRACT_REVIEW_CLEAR_APPLY_RESULT:
      return { ...current, applyResult: undefined, applyError: undefined };
    default:
      return current;
  }
}
